import { useMemo, useState, useEffect } from "react";
import ModalVerifyPhoneCommon from "../ModalVerifyPhoneCommon";
import { useApp } from "../../contexts";
import { getCookie } from "../../utils/helper";
import { KEY_COOKIE } from "../../constants";
import { useSearchParams } from "react-router-dom";
import { agreePolicy } from "../../services/app";
import { ModalPolicy } from "../AffiliateComponent/ModalPolicy";

const VerifyPhone = () => {
  const { user, reloadProfile, T } = useApp();
  const [searchParams] = useSearchParams();
  const [isOpenModal, setIsOpenModal] = useState(true);

  const isVerifyPhoneStatus = useMemo(
    () => Boolean(user?.verify_phone_status ?? 0),
    [user]
  );

  const isUpdatedInformation = useMemo(
    () => Boolean(user?.dob && user?.gender && user?.name),
    [user]
  );

  const onUpdateInformation = () => {
    const sso_token = getCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE)?.access_token;
    const redirect_uri =
      searchParams.get("redirect_uri") ??
      encodeURIComponent(`${process.env.REACT_APP_SSO_BASE_HOME}`);
    let ssoURL = process.env.REACT_APP_SSO_PHONE_VERIFICATION_URL;
    if (isVerifyPhoneStatus && !isUpdatedInformation) {
      ssoURL = process.env.REACT_APP_SSO_PERSONAL_INFORMATION_URL;
    }
    const urlIframe = `${ssoURL}?access_token=${sso_token}&from=web-ams&redirect_uri=${redirect_uri}&lan=${
      user?.language
    }&country_code=${user?.country_code ?? ""}&gender=${
      user.gender ?? ""
    }&dob=${user?.dob ?? ""}`;
    setIsOpenModal(false);
    return window.location.replace(urlIframe);
  };

  const [isOpenModalPolicy, setIsOpenModalPolicy] = useState(false);
  const isConfirmedPolicy = useMemo(
    () => Number(user?.is_agree_policy) === 1 && !!user?.agree_policy_date,
    [user]
  );
  const isAffiliateSource = useMemo(() => {
    const nonAffSources = ["internal_test", "app"];
    return !nonAffSources.includes(user?.source);
  }, [user]);
  useEffect(() => {
    if (!isConfirmedPolicy && isAffiliateSource && !isOpenModal) {
      setIsOpenModalPolicy(true);
    }
  }, [isConfirmedPolicy, isAffiliateSource, isOpenModal]);
  const [isAgreeing, setIsAgreeing] = useState(false);
  const onConfirmPolicy = async () => {
    try {
      setIsAgreeing(true);
      await agreePolicy({
        isIgnoreValidation: true
      });
      setIsOpenModalPolicy(false);
      reloadProfile();
    } catch (error) {
      console.error("Failed to agree policy:", error);
      Notification.error(
        error?.response?.data?.message ??
          T("Something went wrong! Please try again later!")
      );
    } finally {
      setIsAgreeing(false);
    }
  };

  return (
    <div>
      {isOpenModal &&
        (!isVerifyPhoneStatus || !isUpdatedInformation) &&
        !!user?.token &&
        !!user?.id && (
          <ModalVerifyPhoneCommon
            onClose={() => setIsOpenModal(false)}
            onSubmit={onUpdateInformation}
          />
        )}
      {isOpenModalPolicy && (
        <ModalPolicy
          onClose={() => setIsOpenModalPolicy(false)}
          handleSubmit={() => onConfirmPolicy()}
          disable={isAgreeing}
        />
      )}
    </div>
  );
};

export default VerifyPhone;
